var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news_w" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "onlineTit" },
      _vm._l(_vm.navList, function (item, index) {
        return _c(
          "span",
          {
            key: index,
            staticClass: "change",
            class: { actClas: index === _vm.actNum },
            on: {
              click: function ($event) {
                return _vm.tabChange(index)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.actNum === 0
      ? _c("div", [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "courseL" }, [
            _vm.reNewsInfo.length > 0
              ? _c(
                  "div",
                  { staticClass: "list" },
                  _vm._l(_vm.reNewsInfo, function (item) {
                    return _c(
                      "div",
                      { key: item.num, staticClass: "listItem" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tit",
                            on: {
                              click: function ($event) {
                                return _vm.goCharacteristics(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.newsTitle))]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "50px",
                      "text-align": "center",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                ),
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "courseL" }, [
            _vm.reNewsInfo1.length > 0
              ? _c(
                  "div",
                  { staticClass: "list" },
                  _vm._l(_vm.reNewsInfo1, function (item) {
                    return _c(
                      "div",
                      { key: item.num, staticClass: "listItem" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tit",
                            on: {
                              click: function ($event) {
                                return _vm.goCharacteristics(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.newsTitle))]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "50px",
                      "text-align": "center",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.actNum === 1
      ? _c("div", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "courseL",
            },
            [
              _vm.kcszList.length > 0
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "list list2" },
                      _vm._l(_vm.kcszList, function (item) {
                        return _c(
                          "div",
                          { key: item.id, staticClass: "listItem2" },
                          [
                            _c("CourseItem", {
                              attrs: { type: 6, item: item },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "50px",
                        "text-align": "center",
                      },
                    },
                    [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "paginationX" },
                [
                  _vm.total > 0
                    ? _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.page.pageNumber,
                          "page-size": _vm.page.pageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.total,
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.actNum === 2
      ? _c("div", [
          _c("div", { staticClass: "courseL" }, [
            _c("div", { staticClass: "list" }, [
              _c("div", { staticClass: "listItem" }, [
                _c(
                  "div",
                  {
                    staticClass: "tit",
                    on: {
                      click: function ($event) {
                        return _vm.lookDetail(
                          "https://dsxxjy.sizhengwang.cn/ds/zyyx/"
                        )
                      },
                    },
                  },
                  [_vm._v("党史学习教育")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "listItem" }, [
                _c(
                  "div",
                  {
                    staticClass: "tit",
                    on: {
                      click: function ($event) {
                        return _vm.lookDetail(
                          "http://app.people.cn/h5/topic/985?clientVersionCode=183"
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      '\n            "阅读伴我成长"职教学生读党报活动\n          '
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "listItem" }, [
                _c("div", { staticClass: "tit1" }, [
                  _vm._v('\n            【"四史"思政大课】\n            '),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "18px", display: "flex" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "dangshi",
                          on: {
                            click: function ($event) {
                              return _vm.lookDetail(
                                "https://app.people.cn/h5/topic/164"
                              )
                            },
                          },
                        },
                        [_vm._v("党史")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dangshi",
                          on: {
                            click: function ($event) {
                              return _vm.lookDetail(
                                "https://app.people.cn/h5/topic/164"
                              )
                            },
                          },
                        },
                        [_vm._v("新中国史")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "8px", display: "flex" } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "dangshi",
                          on: {
                            click: function ($event) {
                              return _vm.lookDetail(
                                "https://app.people.cn/h5/topic/164"
                              )
                            },
                          },
                        },
                        [_vm._v("改革开放史")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dangshi",
                          on: {
                            click: function ($event) {
                              return _vm.lookDetail(
                                "https://app.people.cn/h5/topic/164"
                              )
                            },
                          },
                        },
                        [_vm._v("社会主义发展史")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.actNum === 3 ? _c("div", [_c("CoordinatorList")], 1) : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [_c("img")])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "onlineTit recourseTit" }, [
      _vm._v("\n      中职\n      "),
      _c("div", { staticClass: "line" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "onlineTit recourseTit" }, [
      _vm._v("\n      高职\n      "),
      _c("div", { staticClass: "line" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }